export default __webpack_public_path__ + "static/media/out-of-reach-location.37b062b1.svg";